module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAASCAYAAABIB77kAAAAAXNSR0IArs4c6QAAAQlJREFUOBFjYEAFvUBuIaoQxbwooAnt2EzpAwr+h2JqWeoFNO8X1Mw5QJoZiMEA5AKYZTCaUkutgWZ+RTN3Odg2IOGIRRJkMbmW6gL1vgdimONB9F8gDgNiOKCWpUpAE58BMbJlIHYG3CYkBqWWSgDNugPE6JZVI9mBwSTXUn6gSRewWNaPYQMWAVIt5QSacRiLZYuAYoxYzMcqRKylLEDdm4EYPRhBYiA5kgAhS0GuB/kC3bJDQDGQr8kC+CydADQR3TJQPILikyKAy1J0y0ApVJwim5A0E7IUlPcUkdRThYnLUlCpAipdaALQLQWVl1Y0sQnJUJiloJrAE0mcpkyQpZE0tYEahgMA6u2KElHLvDUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/arrow_down_black_transparent_13_8.png
// module id = ./src/_asset/sources/assets/images/arrow_down_black_transparent_13_8.png
// module chunks = main